import angular from 'angular';
import _ from 'lodash';
import template from './template.html';
import { CandidateDetailsSection, CandidateDetailsSectionConfig } from '../../../../candidate/details-section';
import { RECRUITER_WORKFLOW_STATUS } from '../../../constants/recruiter-workflow';
import './style.scss';

export class RecruiterCandidateDetailsSection extends CandidateDetailsSection {
    $onChanges() {
        super.$onChanges(...arguments);

        const { candidate, recruiterId } = this;

        this.isLastContactedLabelVisible = this.getLastContactedLabelVisibleState(candidate, recruiterId);
        this.candidateImageSrc = this.getCandidateImageSrc(candidate);
        this.currentCandidateStatus = this.getCurrentCandidateStatus(candidate);
    }

    getLastContactedLabelVisibleState(candidate, recruiterId) {
        const isJobSeekerManualUpdated = _.get(candidate, 'candidateData.predictiveData.isJobSeekerManualUpdated');
        const workflowRecruiterId = _.get(candidate, 'workflow.recruiterId');
        const isJobSeekerManual = _.get(candidate, 'candidateData.predictiveData.isJobSeekerManual');

        return isJobSeekerManualUpdated
            && workflowRecruiterId === recruiterId
            && isJobSeekerManual !== 'unknown';
    }

    getCandidateImageSrc(candidate) {
        const showName = _.get(candidate, 'showName', true);
        const firstPhotoSrc = _.get(candidate, 'candidateData.photos.0', 'assets/img/no_profile_picture_100.jpg');

        return showName && firstPhotoSrc;
    }

    getCurrentCandidateStatus(candidate) {
        return _.get(candidate, 'workflow.recruiterStatus.current', RECRUITER_WORKFLOW_STATUS.PROSPECT);
    }
}

export const RecruiterCandidateDetailsSectionConfiguration = {
    ...CandidateDetailsSectionConfig,
    template,
    bindings: {
        ...CandidateDetailsSectionConfig.bindings,
        recruiterId: '<',
        printMode: '<',
        onOpenJobSeekerEdit: '&',
        isNewSearch: '<',
    },
    controller: RecruiterCandidateDetailsSection,
    controllerAs: 'recruiterCandidateDetailsSectionCtrl'
};

angular
    .module('TALENYA-FE')
    .component('recruiterCandidateDetailsSection', RecruiterCandidateDetailsSectionConfiguration);
